import { forwardRef, useState } from "react";
import { Box } from "@mui/material";

import { getTabOptions } from "./Tabs/utils/getTabOptions";
import CustomTabs from "@/components/CustomTabs";
import CharacteristicCard from "./Tabs/components/CharacteristicCard";
import Section from "@/components/Section";
import { tabsStyles } from "./Tabs/styles";

interface IProps {
  product: IProductDetails;
}

const Details = forwardRef<HTMLDivElement, IProps>(({ product }, ref) => {
  const [activeTab, setActiveTab] = useState(0);
  const tabOptions = getTabOptions(product);

  return (
    <Section pt={0} pb={{ xs: 5, md: 6 }}>
      <Box ref={ref} />
      <CustomTabs
        value={activeTab}
        onChange={setActiveTab}
        type="text"
        options={tabOptions.map((option) => ({ label: option.label }))}
        tabsSx={tabsStyles}
      />
      <CharacteristicCard>{tabOptions[activeTab].component}</CharacteristicCard>
    </Section>
  );
});

export default Details;
